import { mainWeb } from '../../config/net'
const index = `${mainWeb}/OnlineMall/view/CreateOrder.aspx`

export default {
  index
}



// WEBPACK FOOTER //
// ./src/model/pay/resource-url.js